const attachmentMimeByExtension = new Map<string, string>([
  ['.pdf', 'application/pdf'],
  ['.jpg', 'image/jpeg'],
  ['.jpeg', 'image/jpeg'],
  ['.png', 'image/png'],
  ['.webp', 'image/webp'],
  ['.doc', 'application/msword'],
  ['.docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
]);

export function validateHelpdeskAttachments(files: readonly File[]): boolean {
  return (
    files.length <= 5 &&
    files.every((file) => {
      const extension = file.name.slice(file.name.lastIndexOf('.')).toLowerCase();
      const expectedMimeType = attachmentMimeByExtension.get(extension);
      return (
        file.size > 0 &&
        file.size <= 5 * 1024 * 1024 &&
        expectedMimeType !== undefined &&
        (file.type === '' ||
          file.type === 'application/octet-stream' ||
          file.type === expectedMimeType)
      );
    })
  );
}

const attachmentIdentities = new WeakMap<File, string>();
export function attachmentIdentity(file: File): string {
  let identity = attachmentIdentities.get(file);
  if (!identity) {
    identity = crypto.randomUUID();
    attachmentIdentities.set(file, identity);
  }
  return identity;
}

export function commandBody<T>(payload: T, files: readonly File[]): T | FormData {
  if (!validateHelpdeskAttachments(files))
    throw new Error('Choose up to 5 non-empty files, 5 MB each.');
  if (files.length === 0) return payload;
  const body = new FormData();
  body.append('payload', JSON.stringify(payload));
  for (const file of files) body.append('files', file);
  return body;
}
